<template>
  <el-dialog
    title="拒绝审核"
    :visible.sync="dialogVisible"
    width="450px"
    :close-on-click-modal="false"
    :show-close="true"
    center
    append-to-body
  >
    <div class="reject-dialog-content">
      <div class="warning-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <div class="warning-message">{{ title }}</div>
      <el-input
        type="textarea"
        v-model="rejectReason"
        placeholder="请输入拒绝原因"
        :rows="4"
        class="reject-reason"
        v-no-emoji
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'RejectDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      bannerId: {
        type: [Number, String],
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        rejectReason: ''
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      },
      title() {
        const map = new Map([
          ['adGroup', '确定审核不通过吗？拒绝后广告组包含的banner均视为拒绝'],
          ['defaultBanner', '确定审核不通过吗？'],
          ['banner', '确定审核不通过吗？']
        ])
        return map.get(this.type) || '确定审核不通过吗？'
      }
    },
    methods: {
      handleCancel() {
        this.rejectReason = ''
        this.dialogVisible = false
      },
      handleConfirm() {
        if (!this.rejectReason.trim()) {
          this.$message.warning('请输入拒绝原因')
          return
        }

        this.$emit('confirm', {
          id: this.bannerId,
          reason: this.rejectReason
        })
        this.rejectReason = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .reject-dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .warning-icon {
      font-size: 24px;
      color: #f56c6c;
      margin-bottom: 15px;

      i {
        font-size: 24px;
      }
    }

    .warning-message {
      font-size: 14px;
      color: #606266;
      text-align: center;
      margin-bottom: 20px;
      line-height: 1.5;
    }

    .reject-reason {
      width: 100%;
    }
  }

  .dialog-footer {
    text-align: center;
  }

  ::v-deep .el-dialog__header {
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #ebeef5;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
  }

  ::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 15px;
  }
</style>
